import { useEffect, useState } from "react";
import type { ImageURISource } from "react-native";
import { YStack } from "tamagui";
import { Image } from "../Image";
import { FALLBACK_ASPECT_RATIO, isSplit, type ResponsiveImageProps } from "./shared";
const computeInitialRatio = (src: string | ImageURISource, override: number | undefined): number => {
  if (override != null) {
    return override;
  }
  if (typeof src === "object" && src.width != null && src.height != null && src.height > 0) {
    return src.width / src.height;
  }
  return FALLBACK_ASPECT_RATIO;
};
export const ResponsiveImage = ({
  src,
  objectFit = "contain",
  objectPosition,
  alt,
  testID,
  aspectRatio: aspectRatioOverride,
  width,
  height,
  maxWidth,
  maxHeight,
  minWidth,
  minHeight,
  ...spacing
}: ResponsiveImageProps) => {
  const resolvedSrc = isSplit(src) ? src.web : src;
  const [ratio, setRatio] = useState<number>(() => computeInitialRatio(resolvedSrc, aspectRatioOverride));
  useEffect(() => {
    setRatio(computeInitialRatio(resolvedSrc, aspectRatioOverride));
  }, [resolvedSrc, aspectRatioOverride]);
  const srcString = typeof resolvedSrc === "string" ? resolvedSrc : typeof resolvedSrc === "object" && resolvedSrc.uri != null ? resolvedSrc.uri : undefined;
  return <YStack {...spacing} width={width ?? "100%"} height={height} maxWidth={maxWidth} maxHeight={maxHeight} minWidth={minWidth} minHeight={minHeight} aspectRatio={ratio} data-sentry-element="YStack" data-sentry-component="ResponsiveImage" data-sentry-source-file="ResponsiveImage.tsx">
      <Image src={srcString} alt={alt} testID={testID} objectFit={objectFit} objectPosition={objectPosition} width="100%" height="100%" onLoad={event => {
      if (aspectRatioOverride != null) {
        return;
      }
      if (event.target instanceof HTMLImageElement && event.target.naturalWidth > 0 && event.target.naturalHeight > 0) {
        setRatio(event.target.naturalWidth / event.target.naturalHeight);
      }
    }} data-sentry-element="Image" data-sentry-source-file="ResponsiveImage.tsx" />
    </YStack>;
};